import React, { Component } from 'react'

class MobileProductFilter extends Component {
  render() {
    const SVG = this.props.img
    return (
      <button
        type='button'
        className={`flex justify-center items-center rounded-[30px] mb-2.5 h-[40px] ${this.props.active ? 'bg-beige-1 text-black' : 'bg-gray-12 text-white'}`}
        onClick={this.props.toggle}
      >
        { this.props.img && <SVG width='40px' height='40px' /> }
        {
          this.props.children && (
            <span className='text-2xl ml-1.5'>
              { this.props.children }
            </span>
          )
        }
      </button>
    )
  }
}

export default MobileProductFilter
